import React, { useEffect, useState } from "react";
import micro_reporter_api from "../../apis/micro-reporter-api";
import { Button, Modal, Form } from "react-bootstrap";
import noSource from "../../assets/img/no-report.png";
import NavigationBar from "../NavigationBar";
import SideNavigation from "../SideNavigation";
import "../../styles/css/ReportDefinitionList.css";
import Report from "./Report";
import ReportTable from "./ReportTable";
import Utils from "../../libraries/utils";
import searchImage from "../../assets/img/search.png";

const ReportDefinitionList = () => {
  const [isAllReportsPage, setIsAllReportsPage] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [reportDefinitions, setReportDefinitions] = useState([]);
  const [tempReportDefinitions, setTempReportDefinitions] = useState([]);
  const [title, setTitle] = useState("");
  const [count, setCount] = useState(10);
  const [deleteReportVars, setDeleteReportVars] = useState({
    deleteValues: { reportName: "", reportId: "" },
  });
  const [showLoad, setShowLoad] = useState(false);

  useEffect(() => {
    getReportDefinitions();
  }, []);

  const getReportDefinitions = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    let dcid = new URLSearchParams(window.location.search).get("dcid");
    let projectId = new URLSearchParams(window.location.search).get(
      "projectId"
    );
    if (dcid) {
      getAllReportDefinitionsByDatabaseConnectionId(dcid, user.id);
    } else if (projectId) {
      getAllReportDefinitionsByProjectId(projectId, user.id);
    } else {
      getAllReportDefinitions(user.id);
    }
  };

  const getAllReportDefinitionsByProjectId = (projectId, userId) => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        setShowLoad(true);
        await micro_reporter_api
          .get(
            "/micro-reporter/report/find-by-project-id?projectId=" +
              projectId +
              "&userId=" +
              userId
          )
          .then((response) => {
            if (response.data && response.data.list.length > 0) {
              setReportDefinitions(response.data.list);
              setTempReportDefinitions(response.data.list);
              setIsAllReportsPage(true);
              console.log(response.data.list);
              setTitle(
                tempReportDefinitions.databaseConnection[0].project.name
              );
            }
            Utils.loadingScreen("hide");
            setShowLoad(false);
          });
      } catch {
        Utils.loadingScreen("hide");
        setShowLoad(false);
      }
    })();
  };

  //   const projectName = useEffect(() => {
  //     return tempReportDefinitions[0].databaseConnection.project.name;
  //   }, [tempReportDefinitions > 0]);

  const getAllReportDefinitionsByDatabaseConnectionId = (dcid, userId) => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        setShowLoad(true);
        await micro_reporter_api
          .get(
            "/micro-reporter/report/find-by-database-id?dcid=" +
              dcid +
              "&userId=" +
              userId
          )
          .then((response) => {
            if (response.data && response.data.list.length > 0) {
              setReportDefinitions(response.data.list);
              setTempReportDefinitions(response.data.list);
              setIsAllReportsPage(true);
            }
            Utils.loadingScreen("hide");
            setShowLoad(false);
          });
      } catch {
        Utils.loadingScreen("hide");
        setShowLoad(false);
      }
    })();
  };

  const getAllReportDefinitions = (userId) => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        setShowLoad(true);
        let url = "/micro-reporter/report/all?id=" + userId;
        await micro_reporter_api.get(url).then((response) => {
          setReportDefinitions(response.data);
          setTempReportDefinitions(response.data);
          Utils.loadingScreen("hide");
          setShowLoad(false);
        });
      } catch {
        Utils.loadingScreen("hide");
        setShowLoad(false);
      }
    })();
  };

  const renderTable = () => {
    if (tempReportDefinitions.length > 0) {
      return (
        <div>
          <ReportTable
            preDelete={preDelete}
            reportDefinitions={reportDefinitions}
            tempReportDefinitions={tempReportDefinitions}
          />
        </div>
      );
    } else if (tempReportDefinitions.length == 0 && !showLoad) {
      return (
        <div id="record-not-found-div">
          <div id="center-div">
            <img
              src={noSource}
              style={{
                width: "100px",
                marginTop: "20px",
                marginBottom: "15px",
              }}
              alt="No report definition found."
            />
            <br />
            <span>No report definition found!</span>
          </div>
        </div>
      );
    }
  };

  const renderList = (definitions) => {
    return definitions.map((definition) => {
      return <Report preDelete={preDelete} report={definition} />;
    });
  };

  const search = (word) => {
    let temp = [];
    reportDefinitions.map((report) => {
      if (report.name.toLowerCase().includes(word.toLowerCase())) {
        temp.push(report);
      } else if (
        report.databaseConnection.project.name
          .toLowerCase()
          .includes(word.toLowerCase())
      ) {
        temp.push(report);
      }
    });
    setTempReportDefinitions(temp);
    temp = [];
    setCount(10);
  };

  const preDelete = (name, id) => {
    setDeleteReportVars({ deleteValues: { reportName: name, reportId: id } });
    setModalShow(true);
  };

  const deleteReportDefinition = () => {
    (async () => {
      try {
        Utils.loadingScreen("show");
        let user = JSON.parse(localStorage.getItem("user"));
        let headers = {
          userId: user.id,
          username: user.username,
          relatedName: encodeURIComponent(
            deleteReportVars.deleteValues.reportName
          ),
          relatedId: deleteReportVars.deleteValues.reportId,
        };
        const config = { headers };
        await micro_reporter_api
          .post(
            `/micro-reporter/schedule/handle/report/${deleteReportVars.deleteValues.reportId}`
          )
          .then(
            await micro_reporter_api.delete(
              `/micro-reporter/report/delete?id=${deleteReportVars.deleteValues.reportId}`,
              config
            )
          );
        window.location.reload();
        Utils.loadingScreen("hide");
      } catch (err) {
        Utils.loadingScreen("hide");
      }
    })();
  };

  const renderNewReportButton = () => {
    if (JSON.parse(localStorage.getItem("user")).role === "ADMIN") {
      let dcid = new URLSearchParams(window.location.search).get("dcid");
      let projectId = new URLSearchParams(window.location.search).get(
        "projectId"
      );
      let query = "";
      if (projectId) {
        query += "?projectId=" + projectId;
      }
      if (projectId && dcid) {
        query += "&dcid=" + dcid;
      } else if (dcid) {
        query += "?dcid=" + dcid;
      }
      return (
        <Button variant="primary" id="report-add-button">
          <a className="link" href={"/report/form" + query}>
            Create
          </a>
        </Button>
      );
    }
  };

  const loadMore = () => {
    let limit = tempReportDefinitions.length > count ? true : false;
    if (limit) {
      setCount(count + 10);
    }
  };

  return (
    <div>
      <SideNavigation current="reports" />
      <div className="page-order">
        <NavigationBar />
        <div id="connection-form-panel">
          <div style={{ marginBottom: "35px", width: "100%" }}>
            <div className="reports-head-area-left">
              <h5 className="page-title">Reports</h5>
              {isAllReportsPage === true ? (
                <Button
                  variant="primary"
                  id="all-reports-page-button"
                  className="all-reports-page-button"
                >
                  <i class="fa-solid fa-chevron-left"></i>
                  <a className="link" href={"/reports"}>
                    All Reports
                  </a>
                </Button>
              ) : null}
            </div>
            <div className="reports-head-area-right">
              {renderNewReportButton()}
              {/* <input id="reportSearchInput" placeholder="Search Report" /> */}

              <Form>
                <input
                  type="text"
                  name="search"
                  id="userSearchInput"
                  onChange={(event) => search(event.target.value)}
                  placeholder="Search Report"
                  className="extand"
                />
                <img id="seacrhIcon" src={searchImage} alt="search" />
              </Form>
            </div>
          </div>
          {renderTable()}
        </div>
      </div>
      <DeleteReportModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        delete={deleteReportDefinition}
        setDeleteReportVars={setDeleteReportVars}
      />
    </div>
  );
};

function DeleteReportModal(props) {
  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <span id="connection-form-panel-title">Delete Report Definition</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "5px 15px 5px " }}>
          Are you sure want to delete this report?
        </div>
        <span style={{ padding: "5px 15px 5px ", color: "#ff0000" }}>
          This process cancels scheduled operations!
        </span>
        <div></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={props.delete}>
          Delete
        </Button>
        <Button
          variant="success"
          onClick={() => {
            props.setDeleteReportVars({
              deleteValues: { reportName: "", reportId: "" },
            });
            props.onHide();
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ReportDefinitionList;
